<template>
  <div></div>
</template>

<script>
  export default {
    name: 'DashboardCoreFooter',
  }
</script>
